import React, { useMemo } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const ChartsSection = ({ visits }) => {
  // Агрегация по последним 7 дням
  const chartData = useMemo(() => {
    const last7Days = [];
    for (let i = 6; i >= 0; i--) {
      const d = new Date();
      d.setDate(d.getDate() - i);
      last7Days.push(d.toLocaleDateString('ru-RU'));
    }

    const dailyTransitions = new Array(7).fill(0);
    const dailyRegistrations = new Array(7).fill(0);

    visits.forEach(v => {
      const idx = last7Days.indexOf(v.date);
      if (idx !== -1) {
        dailyTransitions[idx]++;
        if (v.targetReached) dailyRegistrations[idx]++;
      }
    });

    return last7Days.map((date, i) => ({
      date: date.slice(0, 5),
      transitions: dailyTransitions[i],
      registrations: dailyRegistrations[i],
      conversion: dailyTransitions[i] === 0 ? 0 : Math.round((dailyRegistrations[i] / dailyTransitions[i]) * 100),
    }));
  }, [visits]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Переходы vs Регистрации (по дням)</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 10 }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: '10px' }} />
              <Bar dataKey="transitions" fill="#3b82f6" name="Переходы" radius={[4, 4, 0, 0]} />
              <Bar dataKey="registrations" fill="#10b981" name="Регистрации" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium">Динамика конверсии (CR%)</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 10 }} domain={[0, 100]} />
              <Tooltip formatter={(value) => `${value}%`} />
              <Line type="monotone" dataKey="conversion" stroke="#f59e0b" strokeWidth={2} dot={{ fill: '#f97316' }} name="Конверсия %" />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
};

export default ChartsSection;